"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPrimitiveInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var Either_1 = require("fp-ts/Either");
var function_1 = require("fp-ts/lib/function");
var Option_1 = require("fp-ts/Option");
var ReadonlyArray_1 = require("fp-ts/ReadonlyArray");
var ReadonlyNonEmptyArray_1 = require("fp-ts/ReadonlyNonEmptyArray");
var Show_1 = require("fp-ts/Show");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var showStringOrNumber = {
    show: function (a) { return "" + a; }
};
var showUndefinedOf = function (s) { return ({
    show: function (a) { return (a === undefined ? '<undefined>' : s.show(a)); }
}); };
/**
 *  @since 0.0.1
 */
exports.showPrimitiveInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.ShowURI,
    date: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)({ show: function (date) { return date.toISOString(); } }, env, {})); }; },
    boolean: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showBoolean, env, {})); }; },
    string: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showString, env, {})); }; },
    number: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showNumber, env, {})); }; },
    bigint: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)({ show: function (a) { return JSON.stringify(a); } }, env, {})); }; },
    stringLiteral: function (_, config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showString, env, {})); }; },
    numberLiteral: function (_, config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showNumber, env, {})); }; },
    oneOfLiterals: function (_, config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(showStringOrNumber, env, {})); }; },
    tag: function (_, config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showString, env, {})); }; },
    keysOf: function (_keys, config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showString, env, {})); }; },
    nullable: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Option_1.getShow(show), env, { show: show })); });
    }; },
    optional: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(showUndefinedOf(show), env, { show: show })); });
    }; },
    mutable: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(show, env, { show: show })); });
    }; },
    array: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(ReadonlyArray_1.getShow(show), env, { show: show })); });
    }; },
    nonEmptyArray: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(ReadonlyNonEmptyArray_1.getShow(show), env, { show: show })); });
    }; },
    uuid: function (config) { return function (env) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Show_1.showString, env, {})); }; },
    either: function (e, a, config) { return function (env) {
        return (function (left, right) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Either_1.getShow(left, right), env, { left: left, right: right })); })(e(env).show, a(env).show);
    }; },
    option: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(Option_1.getShow(show), env, { show: show })); });
    }; },
    unknownE: function (getShow, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType(config_1.showApplyConfig(config)(show, env, { show: show })); });
    }; }
}); });
